import { useState } from 'react';
import './ColorPickerModal.css';

interface ColorPickerModalProps {
  isOpen: boolean;
  currentColor: string;
  onClose: () => void;
  onSave: (color: string) => void;
}

const PRESET_COLORS = [
  '#3388ff', // Blue (default)
  '#ff0000', // Red
  '#00ff00', // Green
  '#ffff00', // Yellow
  '#ff00ff', // Magenta
  '#00ffff', // Cyan
  '#ff8800', // Orange
  '#8800ff', // Purple
  '#000000', // Black
  '#ffffff', // White
  '#808080', // Gray
  '#a52a2a', // Brown
  '#ffc0cb', // Pink
  '#00ff7f', // Spring Green
  '#4b0082', // Indigo
];

const ColorPickerModal = ({ isOpen, currentColor, onClose, onSave }: ColorPickerModalProps) => {
  const [selectedColor, setSelectedColor] = useState(currentColor);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave(selectedColor);
    onClose();
  };

  return (
    <div className="color-picker-overlay" onClick={onClose}>
      <div className="color-picker-modal" onClick={(e) => e.stopPropagation()}>
        <div className="color-picker-header">
          <h3>Choose Color</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="color-picker-body">
          {/* Preset colors */}
          <div className="preset-colors">
            {PRESET_COLORS.map((color) => (
              <button
                key={color}
                className={`color-swatch ${selectedColor === color ? 'selected' : ''}`}
                style={{ backgroundColor: color }}
                onClick={() => setSelectedColor(color)}
                title={color}
              />
            ))}
          </div>

          {/* Custom color picker */}
          <div className="custom-color-section">
            <label htmlFor="custom-color">Custom Color:</label>
            <div className="custom-color-input">
              <input
                id="custom-color"
                type="color"
                value={selectedColor}
                onChange={(e) => setSelectedColor(e.target.value)}
              />
              <input
                type="text"
                value={selectedColor}
                onChange={(e) => setSelectedColor(e.target.value)}
                placeholder="#3388ff"
                className="color-hex-input"
              />
            </div>
          </div>

          {/* Preview */}
          <div className="color-preview">
            <div className="preview-label">Preview:</div>
            <div
              className="preview-box"
              style={{ backgroundColor: selectedColor }}
            />
          </div>
        </div>

        <div className="color-picker-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="save-button" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default ColorPickerModal;
